import React from "react";

export const pageMeta = {
  name: "Web API Intro",
  link: "/javascript/web-api/intro",
};

export default function JavascriptWebApiIntro() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web API Intro</h2>
      <p>Route: /javascript/web-api/intro</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
    </div>
  );
}
